<script setup>
import BookingPanel from '@/Components/BookingPanel.vue'
import BottomInfoPanel from '@/Components/BottomInfoPanel.vue'
import CarPromo from '@/Components/CarPromo.vue'
import FaqAccordion from '@/Components/FaqAccordion.vue'
import Elfsight from '@/Components/elfsight/Elfsight.vue'
import VehicleTypesPanel from '@/Components/VehicleTypesPanel.vue'
import DefaultLayout from '@/Layouts/DefaultLayout.vue'
import YearEndCampaignBanner from '@/Components/campaigns/YearEndCampaignBanner.vue'
import { useBooking } from '@/Stores/booking.js'
import { nextTick, onMounted } from 'vue'
import { useCampaignSchedule } from '@/Composables/useCampaign.js'

defineOptions({ layout: DefaultLayout })

const props = defineProps({
	data: {
		type: Object,
		required: true,
	},
})

const booking = useBooking()

const { showCampaign } = useCampaignSchedule()

onMounted(() => {
	booking.$reset()

	nextTick(() => {
		booking.setOptions(props.data)
	})
})
</script>

<template>
	<div
		class="xl:container mx-auto px-4 md:px-8 wide:px-0 flex flex-col gap-5"
	>
		<YearEndCampaignBanner v-if="showCampaign" />

		<BookingPanel />

		<CarPromo />

		<Elfsight />

		<VehicleTypesPanel />

		<FaqAccordion />

		<BottomInfoPanel />
	</div>
</template>
